import Api from "@/services/api.js";
import Log from "@/services/log.js";
import vTributos from "@/components/v-tributos/v-tributos.vue";
import vSelect from "vue-select";
//import moment from 'moment';
import VueRouter from "vue-router";
import CounterNcm from "@/modules/Pesquisa/components/Head/CounterNcm.vue";
import Paginacao from "@/components/Paginacao/Paginacao.vue";
import SinosMonitoramento from "@/components/Sinos/SinosMonitoramento.vue";
import SinosLegenda from "@/components/Sinos/SinosLegenda.vue";
import ModalProduto from "@/components/ModalProduto/ModalProduto.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import PaginaTitulo from "@/components/PaginaTitulo/PaginaTitulo.vue";
import ProdutoMonitoria from '../../components/ProdutoMonitoria/ProdutoMonitoria.vue';
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import dateFormatMixin from "@/mixins/dateFormatMixin";
import dataSortMixin from "@/mixins/dataSortMixin";

import { mapGetters, mapActions } from "vuex";

var $ = require("jquery");

export default {
  mixins: [dateFormatMixin, dataSortMixin],
  inject: ["pushAlert"],
  // props: ["empresa"],
  data() {
    return {
      tituloModalProduto: "",
      editarProdutoData: null,
      atualizaModal: false,
      teste: [],
      produtosPaginados: null,
      existeTributos: false,
      tributosFiltrados: [],
      alertas: [],
      groupedItems: [],
      opened: [],
      arEstadoIcms: [],
      arFiltro: [],
      arProduto: [],
      arProdutosCadastro: [],
      arTributo: [],
      arTributoEstatico: [],
      arMudanca: [],
      blLoadingTributo: false,
      obProduto: [],
      obProdutoCadastro: [],
      strOrdem: "",
      strPesquisa: "",
      paginate: ["arProduto"],
      blLoading: false,
      blLoadingCadastro: false,
      blLoadingAdicionar: false,
      acesso_simulado: localStorage.getItem("token_simulacao") ? true : false,
      produtoDelete: -1,
      selectedIcms: null,
      produtosLength: 0,
      itensPerPage: 10,
      arFiltrosMonitorados: [],
      blObterTributacaoEstatica: false,
      blForceIcms: false,
      blChecks: {
        pisCofins: false,
        ii: false,
        ie: false,
        cide: false,
        defesa: false,
        ipi: false,
        ai: false
      },
      tooltipModal: "",
      tooltipModalLabel: "",
      tooltipModalAliquota: "",
      empresaSelecionada: {
        id: 0,
        nome: "Selecione uma empresa",
        cnpj: ""
      },
      quantidadeGrid: 10,
      paginacao: [],
      listarPaginas: [],
      blockPage: 0,
      blocks: 0,
      listGrid: [10, 20, 30, 40, 50],
      typeTimeout: null,
      doneTypingInterval: 1000,
      blLoadingExcluir: false,
      assinatura_qtde_produto: 10,
      assinatura_plano: "Premium 01",
      blLoadingFiltrar: false,
      produtoCadastrados: []
    };
  },
  components: {
    vTributos,
    SinosLegenda,
    vSelect,
    ProdutoMonitoria,
    SinosMonitoramento,
    CounterNcm,
    Paginacao,
    ModalProduto,
    BotaoPadrao,
    PaginaTitulo,
    LoadingPadraoContainer
  },

  mounted: function() {
  
  },
  computed: {

    
  },
  watch: {

  },
  created() {

  },
  beforeDestroy() {

  },
  methods: {


    groupBy(array) {
      return array.reduce((acc, item) => {
        let key = item.ncm + item.ex;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});
    },
    toggle(id) {
      // console.log(id);
      if (id.length <= 1) return;
      const index = this.opened.indexOf(id[0].id);
      if (index > -1) {
        this.opened.splice(index, 1); // fecha
      } else {
        this.opened.push(id[0].id); // abre
      }
    },
    toggleTodos(produto) {
      if (this.opened.length == 0) {
        produto.map(p => p[1]).forEach(e => this.toggle(e));
      } else {
        this.opened = [];
      }
    },
    listarProdutos: function(page) {
      if (this.strPesquisa != "") {
        this.filtrarProdutosMonitoria(page);
        return false;
      }

      this.paginacao = [];
      this.listarPaginas = [];
      let that = this;

      if (!this.getEmpresa.id || this.getEmpresa.id == "0") {
        this.setArProdutos([]);
        return false;
      }

      this.arProduto = [];
      this.blLoading = true;

      new Api()
        .get("Produto/obterProdutosMonitoriaRefactory/" + this.getEmpresa.id)
        .then(response => {
          this.setArProdutos(response.dados);
        });
    },

    listarProdutosCadastrados() {
      if (
        !this.getEmpresa ||
        Object.keys(this.getEmpresa).length == 0 ||
        (this.getEmpresa && !this.getEmpresa.id)
      ) {
        this.produtoCadastrados = [];
        return;
      }
      new Api().get("Produto/obterProdutosEmpresa/" + this.getEmpresa.id).then(response => {
        if (!response) {
          this.produtoCadastrados = [];
          return;
        }
        if (response.dados) {
          this.produtoCadastrados = response.dados.filter(f => f.vigente == 1 && f.ncm.length >= 8);
        } else {
          this.produtoCadastrados = [];
        }
      });
    },

    obterTributacaoEstatica(strNcm, ex, id) {
      if (ex == "0") {
        ex = null;
      }
      let that = this;
      new Api()
        .post("Tributacao/obterTributacaoEstatica", {
          strNcm: strNcm,
          ex: ex,
          idProduto: id
        })
        .then(response => {
          //this.arTributoEstatico = response.dados;

          this.arTributoEstatico = that.encontraEspecifica(response.dados);

          that.blObterTributacaoEstatica = true;
        });
    },
    quantidadeProdutos() {
      this.produtosLength = null;
      new Api().get("/Produto/obterProdutosUsuario").then(response => {
        var dados = response.dados;
        this.produtosLength = parseInt(dados.produtos);
      });
    },
    encontraEspecifica(trib) {
      let filtradoEspecifica = trib.filter(e => {
        if (e.descricao == "IPI") {
          if (e.ex != null) {
            return true;
          } else {
            return false;
          }
        }
        if (e.ncm !== "-") return true;
        else return false;
      });

      let filtradoGeral = trib.filter(e => {
        let bol = true;
        $.each(filtradoEspecifica, function(i, f) {
          if (
            e.id_estado == f.id_estado &&
            e.id_tipo_ncm == f.id_tipo_ncm &&
            e.id_tipo_monitoria == f.id_tipo_monitoria &&
            e.descricao == f.descricao &&
            e.sigla == f.sigla
          ) {
            if (e.id_estado > 0) {
              if (e.ncm === "-") {
                bol = false;
              }
            }
            if (e.descricao == "IPI") {
              if (e.ex == null) {
                bol = false;
              }
            }
          }
        });
        return bol;
      });
      return filtradoGeral;
    },

    setArProdutos(arProduto) {
      this.arProdutosCadastro = [];
      if (typeof arProduto !== "boolean") {
        arProduto.map(p => {
          if ((p.monitorado == 0 || p.sugestao == 1) && p.vigente == 1) {
            this.arProdutosCadastro.push(p);
          }
        });
      }

      this.arProduto = [];
      if (typeof arProduto !== "boolean") {
        arProduto.map(p => {
          if (
            (p.vigente == 1 || p.sugestao == 1) &&
            (p.monitorado == 1 || p.monitorado == undefined)
          ) {
            this.arProduto.push(p);
          }
        });
      }

      this.arProdutosCadastro = this.arProdutosCadastro.filter(cadastrado => {
        const found = this.arProduto.find(p => p.id == cadastrado.id);

        return !found;
      });

      const temp = arProduto;

      if (typeof temp !== "boolean") {
        const resultado = this.groupBy(temp);
        this.groupedItems = Object.values(resultado);
      }
      this.abrirModalFromProdutos();

      this.blLoading = false;
    },

    verificaVigencia(inicioVigencia, arIdTipoMonitoria) {
      if (inicioVigencia == null) return true;
      let arData = inicioVigencia.split("-");
      let dateInicioVigencia = new Date(arData);
      let dateNow = new Date();

      if (dateInicioVigencia > dateNow) {
        return new Date(dateInicioVigencia).toLocaleDateString("pt-BR");
      }

      return false;
    },
    verificaMonitoria(obProduto, arIdTipoMonitoria) {
      let vigencia = false;
      let monitorado = false;
      let tipoMonitoramento = false;

      if (obProduto.monitoria.length == 0) {
        return 0;
      } else {
        arIdTipoMonitoria.forEach(tipo => {
          switch (tipo) {
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 12:
              obProduto.monitoria.forEach(produto => {
                if (arIdTipoMonitoria.includes(parseInt(produto.id_tipo_monitoria))) {
                  monitorado = true;
                  tipoMonitoramento = "Completo";
                }
              });
              break;
            case 2:
            case 9:
              let soma = 0;
              obProduto.monitoria.forEach(trib => {
                if (arIdTipoMonitoria.includes(parseInt(trib.id_tipo_monitoria))) {
                  monitorado = true;
                  soma++;
                }
              });
              switch (soma) {
                case 1:
                  tipoMonitoramento = "Completo";
                  break;
                case 2:
                  tipoMonitoramento = "Parcial";
                  break;
              }
              break;
          }
        });
      }

      if (monitorado) {
        this.arMudanca.forEach(trib => {
          if (trib.ncm == obProduto.ncm) {
            arIdTipoMonitoria.forEach(id_mon => {
              obProduto.monitoria.forEach(mon => {
                if (trib.id_tipo_monitoria == id_mon) {
                  vigencia = this.verificaVigencia(trib.inicio_vigencia);
                }
              });
            });
          }
        });

        if (vigencia != false) return vigencia;

        if (tipoMonitoramento == "Completo") {
          return 1;
        } else {
          return 2;
        }
      }

      return 0;
    },

    verificaMonitoriaICMS(obProduto) {
      let vigencia = false;

      // if (obProduto.monitoria.length == 0) {
      // 	return 0;
      // }

      this.arMudanca.forEach(trib => {
        if (trib.ncm == obProduto.ncm) {
          if (trib.tipo == "ICMS") {
            vigencia = this.verificaVigencia(trib.inicio_vigencia);
          }
        }
      });

      if (vigencia != false) return vigencia;

      obProduto.monitoria.some(m => {
        return m.id_tipo_monitoria == 8;
      });

      let intLength = obProduto.icms_estado.length;
      if (intLength == 25) return 2;
      // Foi considerado 25 estados pois MT e CE não estão no RTE
      else if (intLength > 0) return 1;

      return 0;
    },

    obterMudancas: function(form) {
      this.blLoadingButton = true;
      new Api().post("Mudanca/obterMudancas/" + this.empresaSelecionada.id, form).then(response => {
        if (response.dados.length > 0) {
          response.dados.forEach(mudanca => {
            this.arMudanca.push(mudanca);
            this.blLoadingTributo = false;
          });
        }
      });
    },
    openModal(p, arIdTipoMonitoria = []) {
      this.arFiltro = arIdTipoMonitoria;
      this.obProduto = p;
      this.arTributo = [];
      this.arEstadoIcms = [];
      this.selectedIcms = "";

      p.icms_estado.forEach(e => {
        this.arEstadoIcms.push(e.estado);
      });

      if (arIdTipoMonitoria.length == 0) {
        if (this.arEstadoIcms.length > 0) {
          this.selectedIcms = this.arEstadoIcms[0];
        }
      } else {
        this.selectedIcms = "";
      }

      p.monitoria.forEach(e => {
        this.arFiltrosMonitorados.push(parseInt(e.id_tipo_monitoria));
      });

      // this.blLoadingTributo = true;
      // this.obterMudancas(p.id);
      this.obterTributacaoEstatica(p.ncm, p.ex, p.id);

      this.$refs.modalMonitoramento.show();

      this.alteraCheck(arIdTipoMonitoria);
    },
    adicionarProdutoMonitoria() {
      this.tituloModalProduto = "adicionar_monitoria";
      this.editarProdutoData = null;
      this.atualizaModal = !this.atualizaModal;
      this.$root.$emit("bv::show::modal", "ModalProduto");
    },
    editarProdutoMonitoria(prod) {
      this.tituloModalProduto = "monitoria";
      this.editarProdutoData = prod;
      this.atualizaModal = !this.atualizaModal;
      this.$root.$emit("bv::show::modal", "ModalProduto");
    },
    editarProduto(p) {
      this.obProdutoCadastro = p;
      this.$refs.modalCadastro.show();
    },
    onClickExcluir: function() {
      let idProduto = this.produtoDelete.id;
      let that = this;
      let obj = {};

      this.blLoadingExcluir = true;

      new Api()
        .post("Produto/deletarMonitoramento", {
          idProduto: idProduto
        })
        .then(response => {
          // that.arProduto.splice(that.produtoDelete, 1);
          // that.produtoDelete = -1;
          //this.$bus.$emit('excluirProduto', idProduto);

          obj = {
            strUrl: "Produto/deletarMonitoramento",
            intIdItem: idProduto,
            strMetodoHttp: "POST",
            intIdFerramenta: 7,
            intIdTipoAcao: 4,
            strTipoAcao: "Deletar",
            strObjetoClick: "Deletar Monitoramento",
            strDestinoClick: ""
          };
          that.registraLogAcesso(obj);
        })
        .finally(() => {
          this.blLoadingExcluir = false;
          this.$refs.modalApagarProduto.hide();
          //this.listaProdutosEmpresa();
          this.listarProdutos();
          this.listarProdutosCadastrados();
          this.quantidadeProdutos();
          that.blLoadingExcluir = false;
          this.opened = [];
        });
    },
    closeModalApagarProduto: function() {
      this.$refs.modalApagarProduto.hide();
    },
    checkboxFilter(arIdTipoMonitoria = []) {
      arIdTipoMonitoria.forEach(id => {
        if (this.arFiltro.indexOf(id) != -1) {
          this.arFiltro.splice(this.arFiltro.indexOf(id), 1);
        } else {
          this.arFiltro.push(id);
        }
      });

      if (this.arFiltro.length == 0 && this.selectedIcms == "") {
        this.selectedIcms = this.arEstadoIcms[0];
        this.blForceIcms = true;
      } else {
        if (this.blForceIcms == true) {
          this.selectedIcms = "";
          this.blForceIcms = false;
        }
      }
    },
    closeModal: function() {
      this.$refs.modalMonitoramento.hide();
    },
    alertasQuantidade: function() {
      if (!this.filteredProdutos.length) return true;
      if (this.getAssinatura.qtde_produto > this.filteredProdutos.length) return true;

      if (this.getAssinatura.nome_plano == "Premium 01") {
        this.pushAlert(
          "Deseja importar mais produtos? Verifique e adquira outra versão Premium que atenda sua necessidade.",
          "primary"
        );
      } else if (
        this.getAssinatura.nome_plano == "Premium 02" ||
        this.getAssinatura.nome_plano == "Premium 03"
      ) {
        this.pushAlert("Deseja importar mais produtos? Atualize o seu pacote premium.", "primary");
      } else if (this.getAssinatura.nome_plano == "Premium 04") {
        this.pushAlert(
          "Limite de cadastro máximo de produtos atingido. Contrate o serviço de assessoria para monitorar mais produtos.",
          "primary"
        );
      } else {
        this.pushAlert(
          "Limite de cadastro máximo de produtos atingido. Contrate o serviço de assessoria para monitorar mais produtos.",
          "primary"
        );
      }

      return false;
    },
    openModalCadastro: async function() {
      this.tributosFiltrados = [];
      this.blLoadingAdicionar = true;
      await this.obterAssinatura();
      this.blLoadingAdicionar = false;

      const alerta = this.alertasQuantidade();

      if (!alerta) return;

      this.obProdutoCadastro = [];
      this.$refs.modalCadastro.show();
    },
    closeModalCadastro() {
      this.$refs.modalCadastro.hide();
    },
    openModalTooltip(aliq, label, tooltip) {
      this.tooltipModalAliquota = aliq;
      this.tooltipModalLabel = label;
      this.tooltipModal = tooltip;
      this.$refs.modalTooltip.show();
    },
    closeModalTooltip() {
      this.$refs.modalTooltip.hide();
    },

    ordenar: function(strOrdem) {
      if (strOrdem == this.strOrdem) {
        this.reverse = !this.reverse;
        this.groupedItems.reverse();
        return;
      }
      this.reverse = false;
      this.groupedItems.sort((a, b) => {
        if (
          a[0][strOrdem] == "-" ||
          a[0][strOrdem] == "" ||
          a[0][strOrdem] == "0" ||
          b[0][strOrdem] == "-" ||
          b[0][strOrdem] == "" ||
          b[0][strOrdem] == "0"
        ) {
          return a[0][strOrdem] == "-" || a[0][strOrdem] == "" || a[0][strOrdem] == "0" ? 1 : -1;
        }
        return a[0][strOrdem].localeCompare(b[0][strOrdem]);
      });

      this.strOrdem = strOrdem;
    },

    filteredTributos(ncm) {
      return this.arMudanca.filter(mud => {
        if (mud.ncm == ncm) {
          return true;
        }
      });
    },
    strReplace: function(str, var1, var2) {
      if (typeof str == "undefined" || str == null) return "";

      if (typeof var1 == "undefined" || var1 == null) return str;

      if (typeof var2 == "undefined" || var2 == null) return str;

      return str.split(var1).join(var2);
    },

    submitMonitoria: async function(obProduto) {
      let that = this;
      let obj = {};
      this.blLoadingCadastro = true;
      await this.obterAssinatura();
      this.blLoadingCadastro = false;

      let alertasQuantidade = this.alertasQuantidade();
      if (!alertasQuantidade) return false;

      this.blLoadingCadastro = true;

      var countTributos = 0;
      obProduto.arTributos.forEach(tributos => {
        if (tributos === true) {
          countTributos++;
        }
      });

      if (countTributos === 0 && obProduto.icms_estado && obProduto.icms_estado.length === 0) {
        this.alertas = [];
        this.alertas.push({
          msg: "Selecione ao menos uma opção de monitoramento.",
          class: "danger",
          blShow: true
        });
        this.blLoadingCadastro = false;
        return false;
      }

      await new Api()
        .post("Produto/alterarMonitoramento", obProduto)
        .then(response => {
          this.setArProdutos(response.dados);

          this.closeModal();
          //this.closeModalCadastro();

          this.obProdutoCadastro = [];

          this.alertas = [];
          this.alertas.push({
            msg: "Cadastrado com sucesso",
            class: "success",
            blShow: true
          });

          obj = {
            strUrl: "Produto/alterarMonitoramento",
            intIdItem: obProduto.id,
            strMetodoHttp: "POST",
            intIdFerramenta: 7,
            intIdTipoAcao: 3,
            strTipoAcao: "Editar",
            strObjetoClick: "Editar Monitoramento",
            strDestinoClick: ""
          };
          that.registraLogAcesso(obj);
        })
        .finally(() => {
          this.blLoadingCadastro = false;
          this.$refs.modalCadastro.hide();
          this.listarProdutos();
          this.listarProdutosCadastrados();
          //this.listaProdutosEmpresa();
        });

      // location.reload(true);
    },
    tributosEstaticos() {
      let arTemp = [];
      let regime = "";
      let tooltip = "";
      let that = this;

      if (this.selectedIcms) {
        /* icms comum */
        arTemp.push({
          id: 1,
          label: "ICMS",
          aliquota: new Array(),
          aliquota_cofins: new Array(),
          tooltip: new Array(),
          id_tipo_ncm: new Array(),
          id_tipo_tributacao: new Array()
        });

        arTemp.push({
          id: 1,
          label: "Fundo de Combate a Pobreza",
          aliquota: new Array(),
          aliquota_cofins: new Array(),
          tooltip: new Array(),
          id_tipo_ncm: new Array(),
          id_tipo_tributacao: new Array()
        });
      }

      if (this.obProduto.monitoria) {
        this.obProduto.monitoria.forEach(m => {
          if (
            this.arFiltro.length == 0 ||
            this.arFiltro.some(f => {
              return f == m.id_tipo_monitoria;
            })
          ) {
            arTemp.push({
              id: m.id_tipo_monitoria,
              label: m.tipo_monitoria.descricao,
              aliquota: new Array("-"),
              aliquota_cofins: new Array(""),
              tooltip: new Array(""),
              id_operacao: new Array(""),
              id_tipo_ncm: new Array(""),
              id_tipo_tributacao: new Array("")
            });
          }
        });

        this.arTributoEstatico.forEach(t => {
          if (
            !this.obProduto.ex ||
            this.obProduto.ex == 0 ||
            this.obProduto.ex == t.ex ||
            t.ex == null
          ) {
            if (t.id_tipo_monitoria == 1) {
              let blExist =
                this.selectedIcms &&
                this.obProduto.icms_estado.some(icms => {
                  return (
                    icms.id_estado == t.id_estado && this.selectedIcms.id_estado == t.id_estado
                  );
                });

              if (blExist) {
                if (t.id_tipo_ncm == 72 || t.id_tipo_ncm == 73) {
                  arTemp[1].aliquota.push(that.regraAliquota(t));
                  arTemp[1].tooltip.push(t.observacao);
                  arTemp[1].id_tipo_ncm.push(t.id_tipo_ncm);
                  arTemp[1].id_tipo_tributacao.push(t.id_tipo_tributacao);
                } else {
                  arTemp[0].aliquota.push(that.regraAliquota(t));
                  arTemp[0].tooltip.push(t.observacao);
                  arTemp[0].id_tipo_ncm.push(t.id_tipo_ncm);
                  arTemp[0].id_tipo_tributacao.push(t.id_tipo_tributacao);
                }
              }
            } else {
              let blExist = this.obProduto.monitoria.some(m => {
                return (
                  m.id_tipo_monitoria == t.id_tipo_monitoria &&
                  (this.arFiltro.length == 0 ||
                    this.arFiltro.some(f => {
                      return f == m.id_tipo_monitoria;
                    }))
                );
              });

              if (blExist) {
                let index = arTemp.findIndex(temp => temp.id == t.id_tipo_monitoria);

                regime = t.observacao != "-" ? t.observacao : "";
                regime = t.regime_remetente != null ? regime + t.regime_remetente : regime;
                tooltip = regime;
                if (t.descricao == "DEFESA COMERCIAL") {
                  tooltip = t.desc_trib;
                }

                if (t.id_tipo_ncm == 35) {
                  tooltip = "Alíquota Monofásica";
                }

                if (index >= 0 && arTemp[index].aliquota[0] == "-") {
                  arTemp.splice(index, 1);
                  index = -1;
                }

                if (index == -1) {
                  let strAliqConfins = "";

                  if (t.aliquota_cofins != "")
                    strAliqConfins = Number(t.aliquota_cofins).toFixed(2);

                  arTemp.push({
                    id: t.id_tipo_monitoria,
                    label: t.descricao,
                    aliquota: new Array(that.regraAliquota(t)),
                    aliquota_cofins: new Array(strAliqConfins),
                    id_tipo_ncm: new Array(t.id_tipo_ncm),
                    tooltip: new Array(tooltip),
                    id_operacao: new Array(t.id_operacao),
                    id_tipo_tributacao: new Array(t.id_tipo_tributacao)
                  });
                } else {
                  arTemp[index].aliquota.push(that.regraAliquota(t));
                  arTemp[index].tooltip.push(tooltip);
                  arTemp[index].id_operacao.push(t.id_operacao);
                  arTemp[index].id_tipo_ncm.push(t.id_tipo_ncm);
                  arTemp[index].id_tipo_tributacao.push(t.id_tipo_tributacao);

                  if (t.aliquota_cofins != "") {
                    if (
                      !(Number(t.aliquota_cofins).toFixed(2) + "%" == "0%" && t.id_tipo_ncm == 35)
                    )
                      arTemp[index].aliquota_cofins.push(
                        Number(t.aliquota_cofins).toFixed(2) + "%"
                      );
                  }
                }
              }
            }
          }
        });
      }

      if (this.selectedIcms) {
        if (arTemp[1].aliquota.length == 0) arTemp.splice(1, 1);
      }

      // Separa PIS/COFINS
      return this.separaPisCofins(arTemp);
    },
    retornaTooltipResumido(tooltip) {
      if (tooltip != null)
        if (tooltip.length > 400) return tooltip.substring(0, 400) + "...";
        else return tooltip.substring(0, 400);
      else return null;
    },
    retornaAliquotaSemRepeticao(t) {
      let aliquotasExistentes = [];
      let newAliquota = [];
      let lastChange = [];
      let filter = t.aliquota.filter((v, index) => {
        if (aliquotasExistentes[v]) {
          if (t.tooltip[index] != null && t.tooltip[index] != "") {
            newAliquota[index] = v;
            return (aliquotasExistentes[v] = v);
          }
          return false;
        } else {
          newAliquota[index] = v;
          return (aliquotasExistentes[v] = v);
        }
      });

      if (newAliquota.length > 1) {
        newAliquota = newAliquota.filter((f, index) => {
          if (f == "-" || f == null || !f || 0 === f.length) return false;
          else {
            lastChange[index] = f;
            return true;
          }
        });
      } else {
        lastChange = newAliquota;
      }

      return lastChange;
    },
    regraAliquota: function(trib) {
      if (trib.medida_aplicada != null && trib.medida_aplicada != "") {
        return trib.medida_aplicada;
      } else {
        if (trib.aplica == 2) {
          return "-";
        } else if (trib.aplica == 1) {
          return trib.txtAliquota;
        } else if (trib.aplica == 0) {
          return "NT";
        } else {
          return trib.txtAliquota;
        }
      }
    },
    separaPisCofins: function(arTemp) {
      let arFinal = [];

      arTemp.forEach((t, index) => {
        let obIcms = {
          id: 1,
          label: "ICMS",
          aliquota: new Array(),
          aliquota_cofins: new Array(),
          tooltip: new Array(),
          id_tipo_ncm: new Array()
        };

        let obIcmsFcp = {
          id: 1,
          label: "ICMS FCP",
          aliquota: new Array(),
          aliquota_cofins: new Array(),
          tooltip: new Array(),
          id_tipo_ncm: new Array()
        };

        if (t.label != "PIS/COFINS" && t.label != "PIS/COFINS IMPORTAÇÃO") {
          if (t.label == "ICMS") {
            t.id_tipo_tributacao.forEach((tipo_trib, index) => {
              if (tipo_trib == "3" || tipo_trib == "4") {
                obIcmsFcp.aliquota.push(t.aliquota[0]);
                obIcmsFcp.tooltip.push(t.tooltip[0]);
                obIcmsFcp.id_tipo_ncm.push(t.id_tipo_ncm[0]);
              } else {
                if (t.aliquota.length > 1) {
                  obIcms.aliquota.push(t.aliquota[index]);
                  obIcms.tooltip.push(t.tooltip[index]);
                  obIcms.id_tipo_ncm.push(t.id_tipo_ncm[index]);
                } else {
                  obIcms.aliquota.push(t.aliquota[index]);
                  obIcms.tooltip.push(t.tooltip[index]);
                  obIcms.id_tipo_ncm.push(t.id_tipo_ncm[index]);
                }
              }
            });
            if (obIcmsFcp.aliquota.length > 0) arFinal.splice(1, 1, obIcmsFcp);
            if (obIcms.aliquota.length > 0) arFinal.splice(0, 0, obIcms);
          } else {
            arFinal.push(t);
          }
        } else {
          let obPis = {
            id: 1,
            label: "PIS",
            aliquota: new Array(),
            aliquota_cofins: new Array(),
            tooltip: new Array(),
            id_tipo_ncm: new Array()
          };
          let obPisImportacao = {
            id: 1,
            label: "PIS Importação",
            aliquota: new Array(),
            aliquota_cofins: new Array(),
            tooltip: new Array(),
            id_tipo_ncm: new Array()
          };
          let obCofins = {
            id: 1,
            label: "COFINS",
            aliquota: new Array(),
            aliquota_cofins: new Array(),
            tooltip: new Array(),
            id_tipo_ncm: new Array()
          };
          let obCofinsImportacao = {
            id: 1,
            label: "COFINS Importação",
            aliquota: new Array(),
            aliquota_cofins: new Array(),
            tooltip: new Array(),
            id_tipo_ncm: new Array()
          };

          t.id_operacao.forEach((op, index) => {
            if (op == 41) {
              //importação
              if (
                t.aliquota_cofins[index] != "" &&
                !(t.aliquota_cofins[index] == "0.00%" && t.id_tipo_ncm[index] == 27)
              ) {
                obCofinsImportacao.aliquota.push(t.aliquota_cofins[index]);
                obCofinsImportacao.tooltip.push(t.tooltip[index]);
                obCofinsImportacao.id_tipo_ncm.push(t.id_tipo_ncm[index]);
              }
              if (
                t.aliquota[index] &&
                !(t.aliquota[index] == "0.00%" && t.id_tipo_ncm[index] == 27)
              ) {
                obPisImportacao.aliquota.push(t.aliquota[index]);
                obPisImportacao.tooltip.push(t.tooltip[index]);
                obPisImportacao.id_tipo_ncm.push(t.id_tipo_ncm[index]);
              }
            } else if (op != "") {
              if (t.aliquota_cofins[index] != "" && t.id_tipo_ncm[index] != "41") {
                obCofins.aliquota.push(t.aliquota_cofins[index]);
                obCofins.tooltip.push(t.tooltip[index]);
                obCofins.id_tipo_ncm.push(t.id_tipo_ncm[index]);
              }
              if (t.aliquota[index] && t.id_tipo_ncm[index] != "41") {
                obPis.aliquota.push(t.aliquota[index]);
                obPis.tooltip.push(t.tooltip[index]);
                obPis.id_tipo_ncm.push(t.id_tipo_ncm[index]);
              }
            }
          });

          /*
					let pis = [];
					pis.id = '2';
					pis.label = 'PIS';
					pis.aliquota = t.aliquota;
					pis.tooltip = t.tooltip;

					let cofins = [];
					cofins.id = '2';
					cofins.label = 'COFINS';
					cofins.aliquota = t.aliquota_cofins;
					cofins.tooltip = t.tooltip;
					*/

          if (obPis.aliquota.length > 0) arFinal.push(obPis);

          if (obCofins.aliquota.length > 0) arFinal.push(obCofins);

          if (obPisImportacao.aliquota.length > 0) {
            let obPisImportacaoN = (obPisImportacao = {
              ...obPisImportacao,
              aliquota: [obPisImportacao.aliquota[0]]
            });
            arFinal.push(obPisImportacaoN);
          }

          if (obCofinsImportacao.aliquota.length > 0) {
            let resp = false;
            obCofinsImportacao.aliquota.forEach(trib1 => {
              obCofinsImportacao.aliquota.forEach(trib2 => {
                if (trib1 == trib2) {
                  resp = true;
                } else {
                  resp = false;
                }
              });
            });
            if (resp) {
              let obCofinsImportacaoN = (obCofinsImportacao = {
                ...obCofinsImportacao,
                aliquota: [obCofinsImportacao.aliquota[0]]
              });
              arFinal.push(obCofinsImportacaoN);
            } else {
              arFinal.push(obCofinsImportacao);
            }
          }
        }
      });

      /*
			arFinal.forEach((t, index) => {
				let intLength = arFinal[index].aliquota.length;
				arFinal[index].aliquota = intLength > 0 ? arFinal[index].aliquota.substring(0, intLength - 2) : '-';
			});
			*/

      return arFinal;
    },
    alteraCheck: function(arId = []) {
      this.blChecks.cide = false;
      this.blChecks.ipi = false;
      this.blChecks.ii = false;
      this.blChecks.ie = false;
      this.blChecks.defesa = false;
      this.blChecks.pisCofins = false;
      this.blChecks.ai = false;
      if (arId.length == 0) {
        return false;
      }

      let id = arId[0];

      switch (id) {
        case 3:
          this.blChecks.cide = !this.blChecks.cide;
          break;
        case 4:
          this.blChecks.ipi = !this.blChecks.ipi;
          break;
        case 5:
          this.blChecks.ii = !this.blChecks.ii;
          break;
        case 6:
          this.blChecks.ie = !this.blChecks.ie;
          break;
        case 7:
          this.blChecks.defesa = !this.blChecks.defesa;
          break;
        case 12:
          this.blChecks.ai = !this.blChecks.ai;
          break;
        case 2: // 2 e 9: PisCofins
        case 9:
          this.blChecks.pisCofins = !this.blChecks.pisCofins;
          break;
      }
    },
    exibeAliq: function(aliq, t) {
      if (typeof aliq === "undefined" || aliq == "" || aliq == null || aliq == " " || aliq == ",") {
        aliq = "-";
      }

      if (t.label == "CIDE COMBUSTÍVEIS") {
        if (aliq != "-") return aliq + "/m³";
      }

      return aliq;
    },
    registraLogAcesso: function(obj) {
      let assinatura;
      let nome_usuario;

      let testAssinatura = localStorage.getItem("assinatura");
      if (
        testAssinatura &&
        testAssinatura !== undefined &&
        testAssinatura !== "undefined" &&
        testAssinatura != null
      ) {
        assinatura = JSON.parse(localStorage.getItem("assinatura"));
      }

      if (localStorage.getItem("nome_usuario")) {
        nome_usuario = localStorage.getItem("nome_usuario");
      }

      let objFinal = {
        intIdUsuario: assinatura.id_usuario,
        strNomeUsuario: nome_usuario,
        strIP: assinatura.ip,
        strUrl: obj.strUrl,
        strMetodoHttp: obj.strMetodoHttp,
        intIdItem: obj.intIdItem,
        intIdFerramenta: obj.intIdFerramenta,
        strObjetoClick: obj.strObjetoClick,
        strDestinoClick: obj.strDestinoClick,
        intIdTipoAcao: obj.intIdTipoAcao,
        strTipoAcao: obj.strTipoAcao
      };

      new Log().reportAcesso(objFinal);
    },

    changeBlock: function(direction) {
      if (direction == "up") {
        if (this.blockPage == this.blocks) return;
        this.blockPage++;
        if (this.strPesquisa != "") {
          this.filtrarProdutosMonitoria(this.blockPage * 10 + 1);
        } else {
          this.filtrarProdutosMonitoria(this.blockPage * 10 + 1);
        }
      } else {
        if (this.blockPage == 0) return;
        this.blockPage--;
        if (this.strPesquisa != "") {
          this.filtrarProdutosMonitoria(this.blockPage * 10 + 1);
        } else {
          this.filtrarProdutosMonitoria(this.blockPage * 10 + 1);
        }
      }
    },

    btnFiltrarProdutoM: function(event, page) {
      if (this.empresaSelecionada.id === undefined || this.empresaSelecionada.id == 0) {
        return false;
      }

      if ((event.type == "keyup" && event.key == "Enter") || event.type == "click") {
        this.blLoadingFiltrar = true;
        this.filtrarProdutosMonitoria(page);
      }
    },

    filtrarProdutosMonitoria: function(page) {
      this.blLoading = true;
      clearTimeout(this.typeTimeout);

      this.typeTimeout = setTimeout(() => {
        this.paginacao = [];
        this.listarPaginas = [];
        var that = this;

        if (!this.empresaSelecionada.id || this.empresaSelecionada.id == "0") {
          this.setArProdutos([]);
          this.blLoading = false;
          this.blLoadingFiltrar = false;
          return false;
        }

        this.arProduto = [];
        this.blLoading = true;

        new Api()
          .post("Produto/filtrarProdutosMonitoria", {
            termo: this.strPesquisa,
            origem: "m",
            empresa: this.getEmpresa.id,
            limite: this.quantidadeGrid,
            pagina: page
          })
          .then(response => {
            that.produtos = response.dados;

            if (typeof response.mensagem == "object") {
              that.paginacao = response.mensagem;
              that.listarPaginas = that.paginacao.listPages;
              that.blocks = that.paginacao.blocks;
            }

            this.setArProdutos(response.dados);

            that.blLoading = false;
            this.blLoadingFiltrar = false;
          });
      }, this.doneTypingInterval);
    },

    inArray: function(needle, haystack) {
      var length = haystack ? haystack.length : 0;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    }
  }
};
